import { connect } from 'react-redux';
import ConnectableInstanceWidgetStatistic from 'client/components/Instance/components/ConnectableInstanceWidgetStatistic';
import { instanceFatdiReadStatistics } from 'client/redux/fatdi/statisticsActions';
import _ from 'lodash';

const mapStateToProps =  (state, props) => {
  const id = props.statistic;
  return {
    ...(state.fatd.statistics[id] || {}),
    data: _.get(state, ['fatdi', 'statistics', id, 'data', id], null),
  };
};

const actions = {
  readStatistic: instanceFatdiReadStatistics,
};

export default connect(mapStateToProps, actions)(ConnectableInstanceWidgetStatistic);
